import { styled } from "@mui/material";

export const Title = styled("span")(() => ({
  font: "600 16px/24px Manrope",
  color: "#475467",
}));
